import endpoints from '@app/src/api/endpoints'
import type { FetchFacetsOptions } from '@app/src/api/fetchHooks'
import { RESPONSE_ITEM_LATEST_SUBMITTED_FILTER } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import { SortOrder } from '@app/src/types/filter'

/*
  The isLatestSubmitted filter is what lets the backend answer these facets from the
  VW_ResponseItemAccessorData indexed view, which is around ten times faster than
  faceting the response items directly.
 */
const responseItemFacetSettings =
  (facetName: string, isEnum?: boolean) =>
  (key: FetchFacetsOptions['key']): FetchFacetsOptions => ({
    key,
    endpoint: endpoints.responseItemsWithFacets,
    facetsParam: [{ name: facetName, isEnum }],
    filter: [RESPONSE_ITEM_LATEST_SUBMITTED_FILTER],
    sort: { target: 'label', order: SortOrder.ASCENDING },
  })

export const responseItemQuestionnaireFacetSettings = responseItemFacetSettings('response.request.template.title')

export const responseItemQuestionFacetSettings = responseItemFacetSettings('requestItem.template.questionText')

export const responseItemPeriodFacetSettings = responseItemFacetSettings('response.request.periodName', true)

export const responseItemOrganizationFacetSettings = responseItemFacetSettings(
  'response.request.subscriptions.target.name',
)

export const responseItemProviderIdFacetSettings = responseItemFacetSettings('response.request.subscriptions.target.id')
